import React from 'react'
import { FluidGridContainer } from 'components/StaticGrid'
import { useDesktopMediaQuery } from 'utils/hooks/useMediaQueries'
import HamburguerMenu from 'components/HamburguerMenu/HamburguerMenu'
import GlobalActionMenu from 'components/GlobalActionMenu/GlobalActionMenu'

const Header = () => {
  const isDesktop = useDesktopMediaQuery()
  return (
    <div style={{ position: 'relative' }}>
      <FluidGridContainer>
        <div
          style={{
            padding: isDesktop ? '16px 32px 0 32px' : '28px 0',
            flexDirection: 'row',
            alignItems: 'center',
            display: 'flex'
          }}
        >
          <HamburguerMenu style={{ marginRight: 20 }} />
          <GlobalActionMenu style={{ marginLeft: 'auto' }} inNetwork={true} />
        </div>
      </FluidGridContainer>
    </div>
  )
}

export default Header
